import {useAppSelector} from "@Hooks/selector/useAppSelector";

export default function useGetVehicleTotalPrice() {
    const {
        ticket: {
            isReturn,
            addons,
        },
        purchasedRoute: {
            singleRoute,
            returnRoute,
        },
    } = useAppSelector((state) => (state.checkOrder))

    const getAddonPrice = (id: number) => {
        let price = 0;
        if (addons?.singleRouteAddons && singleRoute.prices.priceWithDiscount[1][id]) {
            price += singleRoute.prices.priceWithDiscount[1][id]
        }

        if (isReturn && addons?.returnRouteAddons && returnRoute.prices.priceWithDiscount[2][id]) {
            price += returnRoute.prices.priceWithDiscount[2][id]
        }

        return price
    }

    return {
        getAddonPrice,
    }
}